<template>
  <div class="content" v-on:click="sectionClicked">
    <div class="contentTop">
      <div class="lthHeaderCnt">
        <div class="lBtn add" v-on:click="addContent">
          Add New Product
        </div>
        <div class="searchCnt">
          <form v-on:submit.prevent="search">
            <input type="text" class="field" placeholder="Search content..."
              v-on:input="search" v-model="query">
            <button></button>
          </form>
          <div class="pageBtn refresh" v-on:click="getData"></div>
        </div>
        <div class="pagination">
          <div class="pageInfo">{{((page * limit) + 1).toLocaleString('id')}}-{{((page
            * limit) + results.length).toLocaleString('id')}} dari
            {{total.toLocaleString('id')}}</div>
          <div :class="{pageBtn: 1, pagePrev: 1, disabled: page === 0}"
            v-on:click="prevPage"></div>
          <div :class="{pageBtn: 1, pageNext: 1, disabled: ((page
            * limit) + results.length) >= total}"
            v-on:click="nextPage"></div>
          <div class="pageBtn config" :class="{open: configOpen}"
            v-on:click.stop="configOpen = !configOpen">
            <div class="ddCnt" v-on:click.stop="doNothing" v-if="configOpen">
              <div class="ddItem">
                <h4>Density</h4>
                <div class="radioCnt">
                  <div class="radioItem density" v-on:click="setDensity('default')">
                    <div :class="{radio: 1, checked: density === 'default'}"></div>
                    Comportable
                    <img src="../assets/density-default.png">
                  </div>
                  <div class="radioItem density" v-on:click="setDensity('compact')">
                    <div :class="{radio: 1, checked: density === 'compact'}"></div>
                    Compact
                    <img src="../assets/density-compact.png">
                  </div>
                </div>
              </div>
              <div class="ddItem">
                <h4>Item Per Page</h4>
                <div class="radioCnt">
                  <div class="radioItem" v-on:click="setItemPerPage(5)">
                    <div :class="{radio: 1, checked: limit === 5}"></div>
                    5 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(10)">
                    <div :class="{radio: 1, checked: limit === 10}"></div>
                    10 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(25)">
                    <div :class="{radio: 1, checked: limit === 25}"></div>
                    25 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(50)">
                    <div :class="{radio: 1, checked: limit === 50}"></div>
                    50 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(100)">
                    <div :class="{radio: 1, checked: limit === 100}"></div>
                    100 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(150)">
                    <div :class="{radio: 1, checked: limit === 150}"></div>
                    150 item per page
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tabCnt">
        <div class="tab tab1 published" :class="{active: tabActive === 'published'}"
          v-on:click="selectTab('published')">Published</div>
        <div class="tab tab2 starred" :class="{active: tabActive === 'starred'}"
          v-on:click="selectTab('starred')">Starred</div>
        <div class="tab tab4 unpublished" :class="{active: tabActive === 'unpublished'}"
          v-on:click="selectTab('unpublished')">Unpublished</div>
        <div class="tab tab99 deleted" :class="{active: tabActive === 'deleted'}"
          v-on:click="selectTab('deleted')">Deleted</div>
      </div>
    </div>
    <perfect-scrollbar class="listingCntSc">
      <div class="listingCnt">
        <div class="listingItemCnt">
          <table>
            <tbody v-if="loading">
              <tr>
                <td colspan="5" class="tdLoading">
                  <SkAnimation :thumb="false" :tab="false" :header="false" :type="'article'"/>
                </td>
              </tr>
            </tbody>
            <tbody v-else :class="density">
              <tr>
                <th class="th1">
                  <div class="checkCnt">
                    <div class="checkboxOuter" v-on:click="checkAll">
                      <div class="checkbox" :class="{
                      indeterminate: indeterminate, checked: checkedAll}"></div>
                    </div>
                  </div>
                  <div class="bulkAction" v-if="indeterminate || checkedAll">
                    <div class="actionItem" v-on:click.stop="stockAdjustBulk">
                      <img src="../assets/change.png">
                      Stock adjustment
                    </div>
                    <div class="actionItem" v-on:click.stop="setPricingBulk">
                      <img src="../assets/shopping.png">
                      Set pricing
                    </div>
                    <div class="moreBtnCnt">
                      <div class="moreBtn"
                        v-on:click.stop="actionMore = !actionMore"></div>
                      <div class="more" v-on:click.stop="doNothing" v-if="actionMore">
                        <div class="actionItem" v-on:click.stop="setDiscountBulk">
                          <img src="../assets/discount-o.png">
                          Set discount
                        </div>
                        <div class="actionItem" v-on:click.stop="unpublishBulk"
                          v-if="tabActive === 'published'">
                          <img src="../assets/private-o.png">
                          Unpublish
                        </div>
                        <div class="actionItem" v-on:click.stop="publishBulk"
                          v-else-if="tabActive === 'unpublished'">
                          <img src="../assets/public.png">
                          Publish
                        </div>
                        <div class="divider"></div>
                        <div class="actionItem red" v-on:click.stop="deleteBulk">
                          <img src="../assets/delete.png">
                          <span v-if="tabActive === 'deleted'">Delete permanently</span>
                          <span v-else>Delete selected</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span v-else>Product</span>
                </th>
                <th>Category</th>
                <th>In Stock</th>
                <th colspan="2">Sell Price</th>
              </tr>
              <tr v-if="results.length < 1" class="loadingTr">
                <td colspan="4" class="loadingCnt">
                <div class="dataEmptyCnt" v-if="results.length < 1">
                  <div class="submissionEmpty">
                    <div class="emptyImg"/>
                    <h4>No Content Created Yet</h4>
                    <p>Content for this category will appear here, add new content by clicking
                      add new content button on top of the page.</p>
                  </div>
                </div>
              </td></tr>
              <tr v-for="(item, index) in results" :key="index">
                <td class="td1">
                  <div class="articleCnt">
                    <div class="checkCnt">
                      <div class="checkboxOuter" v-on:click="checkChanged(index, item)">
                        <div class="checkbox" :class="{checked: item.checked}"></div>
                      </div>
                    </div>
                    <div class="thumb" v-if="item.images.length > 0 && item.images[0].media"
                      :style="{'background-image': `url(${item.images[0].media.imageSm})`}">
                      <span class="prizeMore" v-if="item.images.length > 1">
                        +{{item.images.length - 1}}
                      </span>
                    </div>
                    <div class="thumb noImg" v-else></div>
                    <h4>{{item.name}}</h4>
                    <p v-if="item.sku">SKU: {{item.sku}}</p>
                  </div>
                </td>
                <td><span v-if="item.category">{{item.category.name}}</span>
                  <span v-else>Uncategorized</span>
                </td>
                <td><span v-if="item.inStock > 0">
                    {{item.inStock.toLocaleString('id')}}</span>
                  <span class="outOfStock" v-else>Out of stock</span>
                  <span class="runingOut" v-if="item.inStock > 0
                    && item.inStock <= 5">Runing out</span>
                  <span class="available" v-else-if="item.inStock > 5">
                    Available</span>
                </td>
                <td>
                  <div v-if="item.sellPrice">
                    Rp <template v-if="item.discountedPrice">
                      {{item.discountedPrice.toLocaleString('id')}}</template>
                    <template v-else>{{item.sellPrice.toLocaleString('id')}}</template>
                    <div class="discount" v-if="item.discount">Disc.
                      <template v-if="item.discountType === 'percentage'">
                        {{item.discount}}%</template>
                      <template v-else>Rp
                        {{item.discount.toLocaleString('id')}}</template>
                      <div class="discountInfo">
                        <div class="diItem">
                          Base Price
                          <span>Rp {{item.sellPrice.toLocaleString('id')}}</span>
                        </div>
                        <div class="diItem">
                          Discount <template v-if="item.discountType === 'percentage'">
                            ({{item.discount}}%)</template>
                          <span>Rp {{(item.discountedPrice
                            - item.sellPrice).toLocaleString('id')}}</span>
                        </div>
                        <div class="diItem">
                          Sell Price
                          <span>Rp {{item.discountedPrice.toLocaleString('id')}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span v-else class="priceFree">Free</span>
                </td>
                <td class="tdAction">
                  <div class="actionWrapper">
                    <div class="variant">3 Variants</div>
                    <div class="action stats" v-on:click.stop="openStats(item)"
                      v-if="item.isDeleted === 0 && item.status === 'published'">
                    </div>
                    <div :class="{action: true, star: true, stared: item.featured}"
                      v-on:click.stop="featured(item, index)"
                      v-if="item.isDeleted === 0"></div>
                    <div class="action" v-on:click="itemOpenedId = item.id"></div>
                    <div :class="{actionOverlay: true, open: itemOpenedId == item.id}"
                      v-on:click="itemOpenedId = null"></div>
                    <div :class="{actionCnt: true, open: itemOpenedId == item.id}"
                      v-if="item.isDeleted === 1">
                      <div class="actionItem" v-on:click="restoreItem(index, item)">
                        <img src="../assets/move-file.png"> Restore
                      </div>
                      <div class="divider"></div>
                      <div class="actionItem actionRed" v-on:click="deletePermanent(index, item)">
                        <img src="../assets/delete.png"> Delete permanent
                      </div>
                    </div>
                    <div :class="{actionCnt: true, open: itemOpenedId == item.id}"
                      v-else>
                      <div class="actionItem" v-on:click="editData(index, item)">
                        <img src="../assets/edit-black.png"> Edit Data
                      </div>
                      <a :href="`${$config.frontEnd}${item.code}`"
                        v-on:click="itemOpenedId = null" class="actionItem"
                        v-if="item.status === 'published'" target="_blank">
                        <img src="../assets/external-link-black.png"> Open Content
                      </a>
                      <div class="actionItem" v-on:click="copyUrl(index, item)"
                        v-if="item.status === 'published'">
                        <img src="../assets/copy.png"> Copy Content Url
                      </div>
                      <div class="actionItem" v-on:click="unpublish(index, item)"
                        v-if="item.status === 'published'">
                        <img src="../assets/private-o.png"> Unpublish
                      </div>
                      <div class="actionItem" v-on:click="publish(index, item)"
                        v-if="item.status === 'pending' || item.status === 'unpublished'">
                        <img src="../assets/public.png"> Publish
                      </div>
                      <div class="divider"></div>
                      <div class="actionItem actionRed" v-on:click="deleteData(index, item)">
                        <img src="../assets/delete.png"> Delete
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="tableInfo" v-if="!loading">
            Displaying {{limit.toLocaleString('id')}}
            of {{total.toLocaleString('id')}}
            items<br />&copy; {{$config.copyright}}. Powered by <a href="https://cmsriver.com"
            target="_blank">CMSRiver</a>
          </div>
        </div>
      </div>
    </perfect-scrollbar>

    <Confirmation ref="confirmDialog"/>
    <Snackbar ref="snackbar"/>
    <LoadingDialog ref="loadingDialog" />
    <FormInputerShort ref="formInputer"/>
    <Analytic ref="analytic"/>
    <AddProduct ref="addProduct"/>
    <StockAdjustment ref="stockAdjustment"/>
    <SetPricing ref="setPricing"/>
    <SetDiscount ref="setDiscount"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import SkAnimation from '@/components/SkAnimation.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';
import Analytic from '@/components/Analytic.vue';
import AddProduct from '@/components/AddProduct.vue';
import StockAdjustment from '@/components/StockAdjustment.vue';
import SetPricing from '@/components/SetPricing.vue';
import SetDiscount from '@/components/SetDiscount.vue';

export default {
  name: 'articles',
  components: {
    Confirmation,
    Snackbar,
    SkAnimation,
    LoadingDialog,
    FormInputerShort,
    Analytic,
    AddProduct,
    StockAdjustment,
    SetPricing,
    SetDiscount,
  },
  data() {
    return {
      limit: 25,
      page: 0,
      total: 0,
      density: 'default',
      parent: null,
      loading: true,
      results: [],
      itemOpenedId: null,
      searchTimer: null,
      query: '',
      tabActive: 'published',
      configOpen: false,
      filterOpen: false,
      indeterminate: false,
      checkedAll: false,
      actionMore: false,
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    sectionClicked() {
      this.configOpen = false;
      this.actionMore = false;
    },
    checkAll() {
      const checkStatus = (!this.indeterminate && !this.checkedAll);
      this.checkedAll = checkStatus;
      this.indeterminate = false;
      // eslint-disable-next-line
      for (const item of this.results) {
        item.checked = checkStatus;
      }
    },
    checkChanged(i, item) {
      // eslint-disable-next-line
      item.checked = !item.checked;
      this.checkedAll = true;
      let hasCheck = false;
      // eslint-disable-next-line
      for (const item of this.results) {
        if (item.checked) hasCheck = true;
        else this.checkedAll = false;
      }
      if (!this.checkedAll && hasCheck) this.indeterminate = true;
    },
    selectTab(tab) {
      if (tab === this.tabActive) return;
      this.tabActive = tab;
      window.history.replaceState({}, tab, `/products?tab=${tab}`);
      this.page = 0;
      this.getData();
    },
    setDensity(density) {
      this.configOpen = false;
      localStorage.setItem('articleDensity', density);
      this.density = density;
    },
    setItemPerPage(itemPerPage) {
      this.configOpen = false;
      localStorage.setItem('articleItemPerPage', itemPerPage);
      this.limit = itemPerPage;
      this.getData();
    },
    search(e) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getData();
      }, 500);
    },
    copyUrl(i, item) {
      this.itemOpenedId = null;
      const urlToCopy = `${this.$config.frontEnd}${item.code}`;
      this.copyToClp(urlToCopy);
    },
    copyToClp(txt2copy) {
      const m = document;
      const txt = m.createTextNode(txt2copy);
      const w = window;
      const b = m.body;
      b.appendChild(txt);
      if (b.createTextRange) {
        const d = b.createTextRange();
        d.moveToElementText(txt);
        d.select();
        m.execCommand('copy');
      } else {
        const d = m.createRange();
        const g = w.getSelection;
        d.selectNodeContents(txt);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand('copy');
        g().removeAllRanges();
      }
      txt.remove();
      this.$refs.snackbar.open({ content: 'Product url copied to clipboard.' });
    },
    deletePermanent(i, item) {
      this.itemOpenedId = null;
      const name = (item.name) ? item.name : 'Content';
      this.$refs.confirmDialog.open({
        title: `Delete ${name}`,
        desc: `Are you sure you want to delete this product permanently?
          This operation can not be undone.`,
      }, (b) => {
        if (b) this.deleteNow2(i, item);
      });
    },
    editData(i, item) {
      this.itemOpenedId = null;
      this.$refs.addProduct.open(item, (b, o) => {
        if (!b) return;
        this.getData();
      });
    },
    restoreItem(i, item) {
      this.itemOpenedId = null;
      const name = (item.name) ? item.name : 'Content';
      this.$refs.confirmDialog.open({
        title: `Restore ${name}`,
        desc: 'Are you sure you want to restore this content?',
        action: 'Restore',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$http.get(this.$config.uri(`product/${item.id}/restore`)).then((r) => {
          if (r.data.status !== 200) {
            // Display error
            return;
          }
          this.$refs.snackbar.open({ content: 'Content has been restored.' });
        });
      });
    },
    deletePeserta(i, item) {
      this.$refs.confirmDialog.open({
        title: 'Feature not available',
        desc: 'Please contact developer to unlock this feature.',
        error: true,
      });
    },
    deleteData(i, item) {
      this.itemOpenedId = null;
      const name = (item.name) ? item.name : 'Content';
      this.$refs.confirmDialog.open({
        title: `Delete ${name}`,
        desc: `Are you sure you want to delete this content?
          You can find deleted item in Deleted tab.`,
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$http.get(this.$config.uri(`product/${item.id}/delete`)).then((r) => {
          if (r.data.status !== 200) {
            // Display error
            return;
          }
          this.$refs.snackbar.open({ content: 'Content has been deleted.', action: 'Undo' }, (sb) => {
            if (sb) this.undoDelete(i, item);
          });
        });
      });
    },
    publish(i, item) {
      this.itemOpenedId = null;
      this.$refs.confirmDialog.open({
        title: 'Publish Product',
        desc: `Are you sure you want to publish this product?
          Product will appear in front-end.`,
        action: 'Publish',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$refs.snackbar.open({ content: 'Product has been published.' });
        this.$http.get(this.$config.uri(`product/${item.id}/publish`));
      });
    },
    unpublish(i, item) {
      this.itemOpenedId = null;
      this.$refs.confirmDialog.open({
        title: 'Unpublish Product',
        desc: `Are you sure you want to unpublish this product?
          Product will not visible in front-end.`,
        action: 'Unpublish',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$refs.snackbar.open({ content: 'Product has been unpublished.' });
        this.$http.get(this.$config.uri(`product/${item.id}/unpublish`));
      });
    },
    deleteNow2(i, item) {
      this.$refs.formInputer.open({
        title: 'Input Password',
        subtitle: `To prevent from accidentally deleted content,
          you need to input your password.`,
        placeholder: 'Password',
        type: 'password',
        action: 'Delete Content',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$http.get(this.$config.uri(`product/${item.id}/delete2`))
          .then((response) => {
            if (response.data.status !== 200) {
              // Display error
              return;
            }
            this.$refs.snackbar.open({ content: 'Content has been deleted.' });
          });
      });
    },
    undoDelete(i, item) {
      this.$http.get(this.$config.uri(`product/${item.id}/restore`)).then((r) => {
        if (r.data.status !== 200) {
          // Display error
          return;
        }
        this.getData();
        this.$refs.snackbar.open({ content: 'Content has been restored.' });
      });
    },
    addContent() {
      this.$refs.addProduct.open({}, (b, o) => {
        if (!b) return;
        this.getData();
      });
    },
    nextPage() {
      if (((this.page * this.limit) + this.results.length) >= this.total) return;
      this.page += 1;
      this.getData();
    },
    prevPage() {
      if (this.page === 0) return;
      this.page -= 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.checkedAll = false;
      this.indeterminate = false;
      const uri = `product/all/admin?limit=${this.limit}&status=${this.tabActive}`
        + `&page=${this.page}&q=${this.query}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loading = false;
        this.results = (r.data.status === 200) ? r.data.data : [];
        this.total = (r.data.status === 200) ? r.data.total : 0;
      });
    },
    openStats(item) {
      this.$refs.analytic.open(item);
    },
    featured(item, index) {
      const featured = (item.featured) ? 0 : 1;
      this.results[index].featured = featured;
      this.$http.get(this.$config.uri(`product/${item.id}/featured/${featured}`));
    },
    stockAdjustBulk() {
      this.$refs.stockAdjustment.open(this.results, (b, v) => {
        if (!b) return;
        let i = 0;
        // eslint-disable-next-line
        for (const item of this.results) {
          if (item.checked) {
            item.inStock = v[i].inStock;
          }
          i += 1;
        }
      });
    },
    setPricingBulk() {
      this.$refs.setPricing.open(this.results, (b, v) => {
        if (!b) return;
        let i = 0;
        // eslint-disable-next-line
        for (const item of this.results) {
          if (item.checked) {
            item.inStock = v[i].inStock;
          }
          i += 1;
        }
      });
    },
    setDiscountBulk() {
      this.moreOpen = false;
      this.$refs.setDiscount.open(this.results, (b, v) => {
        if (!b) return;
        let i = 0;
        // eslint-disable-next-line
        for (const item of this.results) {
          if (item.checked) {
            item.discount = v[i].discount;
          }
          i += 1;
        }
      });
    },
    unpublishBulk() {
      this.moreOpen = false;
      this.itemOpenedId = null;
      this.$refs.confirmDialog.open({
        title: 'Unpublish Selected Products',
        desc: `Are you sure you want to unpublish selected products?
          Products will not visible in front-end.`,
        action: 'Unpublish',
      }, async (b) => {
        if (!b) return;
        this.$refs.loadingDialog.open();
        // eslint-disable-next-line
        for (const item of this.results) {
          if (item.checked) {
            // eslint-disable-next-line
            await this.$http.get(this.$config.uri(`product/${item.id}/unpublish`));
          }
        }
        this.$refs.snackbar.open({ content: 'Selected products has been unpublished.' });
        this.$refs.loadingDialog.close();
        this.getData();
      });
    },
    publishBulk() {
      this.moreOpen = false;
      this.itemOpenedId = null;
      this.$refs.confirmDialog.open({
        title: 'Publish Selected Products',
        desc: `Are you sure you want to publish selected products?
          Products will appear in front-end.`,
        action: 'Publish',
      }, async (b) => {
        if (!b) return;
        this.$refs.loadingDialog.open();
        // eslint-disable-next-line
        for (const item of this.results) {
          if (item.checked) {
            // eslint-disable-next-line
            await this.$http.get(this.$config.uri(`product/${item.id}/publish`));
          }
        }
        this.$refs.snackbar.open({ content: 'Selected products has been published.' });
        this.$refs.loadingDialog.close();
        this.getData();
      });
    },
    deleteBulk() {
      this.moreOpen = false;
      this.itemOpenedId = null;
      const title = (this.tabActive === 'deleted')
        ? 'Delete Selected Products Permanently'
        : 'Delete Selected Products';
      this.$refs.confirmDialog.open({
        title,
        desc: `Are you sure you want to delete selected products?
          Products will not visible in front-end.`,
        action: 'Delete',
      }, async (b) => {
        if (!b) return;
        this.$refs.loadingDialog.open();
        // eslint-disable-next-line
        for (const item of this.results) {
          if (item.checked) {
            const uri = (this.tabActive === 'deleted')
              ? `product/${item.id}/delete2`
              : `product/${item.id}/delete`;
            // eslint-disable-next-line
            await this.$http.get(this.$config.uri(uri));
          }
        }
        this.$refs.snackbar.open({ content: 'Selected products has been deleted.' });
        this.$refs.loadingDialog.close();
        this.getData();
      });
    },
  },
  mounted() {
    this.chCGB(false);
    this.chTitle('All Products');
    this.density = localStorage.getItem('articleDensity') || 'default';
    this.limit = (localStorage.getItem('articleItemPerPage'))
      ? parseInt(localStorage.getItem('articleItemPerPage'), 10) : 25;
    this.tabActive = (this.$route.query && this.$route.query.tab)
      ? this.$route.query.tab : 'published';
    this.getData();
  },
};
</script>


<style scoped lang="scss">
.dataEmptyCnt{
  position: relative;
  height: calc(100vh - 95px);
}
.submissionEmpty{
  text-align: center;
  position: absolute;
  left: 50%; top: 50%;
  transform: translate(-50%, -50%);
  h4{
    margin: 0;
    font-size: 32px;
    color: #767676;
    font-weight: normal;
    margin-bottom: 10px;
  }
  p{
    font-size: 15px;
    color: #767676;
    margin-bottom: 30px;
    max-width: 500px;
    white-space: normal;
    line-height: 1.4;
  }
  .btn{
    // border: #0747a6 2px solid;
    border-radius: 50px;
  }
  .emptyImg{
    width: 300px; height: 300px;
    background-image: url(../assets/trash-empty.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 auto 20px;
  }
}
.listingItemCnt{
  margin: 0 -30px;
}
.listingHeader{
  padding: 5px 20px;
  padding-left: 18px;
  .exportAll{
    float: right;
    background-color: #0057d8;
    font-size: 15px;
    margin-right: 10px;
    padding: 8px 16px;
    border-radius: 40px;
    transition: all .2s linear;
    color: #fff;
    cursor: pointer;
    img{
      height: 20px;
      margin-bottom: -4px;
      margin-right: 5px;
    }
  }
  .exportAll:hover{
    background-color: #0067ff;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  }
  .lhItem{
    font-size: 15px;
    float: left;
    margin-right: 10px;
    padding: 8px 16px;
    border-radius: 40px;
    opacity: .5;
    transition: all .2s linear;
    cursor: pointer;
    position: relative;
    padding-left: 150px;
    float: none;
    margin-right: 0;
    img{
      height: 20px;
      margin-bottom: -4px;
      margin-right: 5px;
    }
    .checkAll{
      width: 14px; height: 14px;
      border: #777 2px solid;
      border-radius: 4px;
      float: left;
      margin-right: 10px;
    }
    &.addContent{
      display: block;
      color: #444;
    }
  }
  .lhItem.rejectAll{
    opacity: 1;
    color: red;
  }
  .lhItem:before{
    content: "";
    position: absolute;
    left: 12px; top: 2px;
    width: 120px; height: 30px;
    background-color: #ddd;
    border-radius: 4px;
  }
  .lhItem:hover{
    // background-color: #eee;
    opacity: 1;
  }
}
table{
  border-collapse: collapse;
  width: 100%;
  tr{
    &:hover{
      // background-color: #f5f5fe;
    }
    &.loadingTr{
      cursor: default;
      &:hover{
        background-color: #fff;
      }
    }
    th{
      text-align: left;
      font-weight: bold;
      color: #999;
      padding: 0;
      height: 54px;
      vertical-align: middle;
      padding-left: 20px;
      border-bottom: #eee 1px solid;
      text-transform: uppercase;
      white-space: nowrap;
      &.th1{
        padding-left: 68px;
        position: relative;
        .checkCnt{
          margin: 0;
          position: absolute;
          left: 30px; top: 50%;
          margin-top: -10px;
          .checkboxOuter{
            .checkbox.indeterminate,
            .checkbox.checked{
              background-color: #0e5dd2 !important;
              border-color: #0e5dd2 !important;
            }
          }
        }
        .bulkAction{
          display: flex;
          margin-left: -10px;
          .divider{
            border-top: #eee 1px solid;
            margin: 10px 0;
          }
          .actionItem{
            display: flex;
            align-items: center;
            padding: 6px 14px;
            border-radius: 50px;
            // border: #eee 1px solid;
            color: #444;
            text-transform: none;
            font-weight: 500;
            margin-right: 5px;
            cursor: pointer;
            transition: all .3s ease;
            &.red{
              color: red;
            }
            &:hover{
              background-color: #f5f5f5;
            }
            img{
              height: 22px;
              margin-right: 10px;
            }
          }
          .moreBtnCnt{
            position: relative;
            z-index: 991;
            .moreBtn{
              width: 34px; height: 34px;
              cursor: pointer;
              transition: all .3s ease;
              background-image: url(../assets/more.png);
              background-size: 16px auto;
              background-position: center;
              background-repeat: no-repeat;
              border-radius: 50%;
              &:hover{
                background-color: #f5f5f5;
              }
            }
            .more{
              position: absolute;
              right: 0; top: 100%;
              background-color: #fff;
              padding: 10px 0;
              border-radius: 5px;
              box-shadow: 0 2px 10px rgba(0, 0, 0, .2);
              font-size: 15px;
              .actionItem{
                margin: 0;
                padding: 10px 22px;
                border-radius: 0;
                img{
                  height: 18px;
                }
              }
            }
          }
        }
        h4{
          margin: 0;
          font-size: 17px;
          font-weight: normal;
          white-space: normal;
          span{
            background: #777;
            color: #fff;
            font-size: 15px;
            padding: 2px 7px;
            border-radius: 3px;
            margin-left: 10px;
            margin-top: 5px;
          }
        }
      }
    }
    td{
      padding: 12px 0;
      padding-left: 20px;
      border-bottom: #eee 1px solid;
      position: relative;
      white-space: nowrap;
      vertical-align: top;
      &.tdLoading{
        padding: 0 30px;
        // border: none;
        &:hover{
          background-color: #fff;
        }
      }
      &.loadingCnt{
        padding: 0 30px;
        border-bottom: none;
      }
      .thumb{
        left: 68px;
        top: 9px;
        position: absolute;
        width: 48px;
        height: 48px;
        // height: 80px;
        // top: 20px;
        background-color: #e5e5e5;
        // background-color: #fff;
        background-size: cover;
        background-position: top center;
        background-repeat: no-repeat;
        border-radius: 4px;
        opacity: 1;
        display: inline-block;
        &.noImg{
          background-image: url(../assets/image-white.png);
          background-size: 24px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        .prizeMore{
          color: #fff;
          font-size: 12px;
          position: absolute;
          right: 6px; bottom: 4px;
        }
      }
      .runingOut,
      .outOfStock,
      .available{
        display: block;
        font-weight: 600;
        color: #ff9600;
        display: flex;
        align-items: center;
        margin-top: 4px;
        &:before{
          content: "";
          width: 8px; height: 8px;
          border-radius: 50%;
          background-color: orange;
          margin-right: 6px;
        }
      }
      .discount{
        color: red;
        font-size: 14px;
        display: flex;
        position: relative;
        align-items: center;
        margin-top: 4px;
        &:before{
          content: "";
          width: 16px; height: 16px;
          border-radius: 50%;
          margin-right: 5px;
          background-image: url(../assets/discount-red.png);
          background-size: contain;
          background-repeat: no-repeat;
        }
        .discountInfo{
          position: absolute;
          color: #444;
          background-color: #fff;
          padding: 10px 16px;
          border: #eee 1px solid;
          border-radius: 5px;
          bottom: 100%; left: -60px;
          margin-bottom: 8px;
          display: none;
          &:before{
            content: "";
            position: absolute;
            transform: translateX(-50%);
            left: 50%;
            bottom: -8px;
            border-top: #eee 8px solid;
            border-left: transparent 8px solid;
            border-right: transparent 8px solid;
          }
          &:after{
            content: "";
            position: absolute;
            transform: translateX(-50%);
            left: 50%;
            bottom: -6px;
            border-top: #fff 6px solid;
            border-left: transparent 6px solid;
            border-right: transparent 6px solid;
          }
          .diItem{
            display: flex;
            width: 160px;
            span{
              margin-left: auto;
            }
          }
        }
        &:hover{
          .discountInfo{
            display: block;
          }
        }
      }
      .outOfStock{
        color: red;
        &:before{
          background-color: red;
        }
      }
      .available{
        color: #00b700;
        &:before{
          background-color: #00b700;
        }
      }
      .priceFree{
        color: #0e5dd2;
        border: #0e5dd2 1px solid;
        padding: 2px 6px;
        // text-transform: uppercase;
        border-radius: 3px;
      }
      .actionWrapper{
        position: relative;
        display: flex;
        justify-content: flex-end;
        padding-right: 10px;
        .ttCnt{
          position: relative;
          .tt{
            position: absolute;
            top: 100%; right: -20px;
            background-color: rgba(0,0,0,.8);
            color: #fff;
            padding: 4px 10px;
            border-radius: 3px;
            display: none;
            font-size: 13px;
          }
          &:hover{
            .tt{
              display: block;
            }
          }
        }
      }
      .deliveryStats{
        display: flex;
        font-size: 13px;
        align-items: center;
        color: #767676;
        .statsItem{
          padding: 5px 10px;
          padding-left: 32px;
          position: relative;
          border-radius: 50px;
          cursor: pointer;
          &:before{
            content: "";
            position: absolute;
            left: 10px; top: 0; bottom: 0;
            width: 16px;
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            opacity: .5;
          }
          &:hover{
            background-color: #d7d7ea;
            color: #444;
            &:before{
              opacity: .6;
            }
          }
          &.waStats{
            &:before{
              background-image: url(../assets/whatsapp-o.png);
            }
          }
          &.smsStats{
            &:before{
              background-image: url(../assets/sms-o.png);
            }
          }
        }
      }
      .variant{
        font-weight: 600;
        line-height: 30px;
        margin-right: 10px;
        color: #767676;
        position: relative;
        text-transform: uppercase;
        display: none;
      }
      .status{
        font-weight: 600;
        line-height: 30px;
        margin-right: 10px;
        color: #767676;
        position: relative;
        &:before{
          content: "";
          position: absolute;
          width: 8px; height: 8px;
          border-radius: 50%;
          background-color: #ccc;
          top: 50%; margin-top: -4px;
          left: -16px;
        }
        &.not_started{
          &:before{
            background-color: orange;
          }
        }
        &.live{
          color: red;
          margin-right: 14px;
          margin-top: -4px;
          &:after{
            content: "";
            position: absolute;
            left: -24px; top: 4px; right: -8px; bottom: 6px;
            border: red 1px solid;
            border-radius: 3px;
          }
          &:before{
            margin-top: -5px;
            background-color: red;
            animation: blinking 1.2s ease forwards infinite;
          }
        }
        &.completed{
          &:before{
            background-color: green;
          }
        }
      }
      .action{
        margin-top: -4px;
        position: relative;
        width: 34px;
        height: 34px;
        border-radius: 50%;
        background-image: url(../assets/more.png);
        background-size: 18px auto;
        background-repeat: no-repeat;
        background-position: center;
        opacity: .4;
        cursor: pointer;
        &.star{
          background-image: url(../assets/star.png);
          &.stared{
            opacity: 1;
            background-image: url(../assets/star-active.png);
          }
        }
        &.share{
          background-image: url(../assets/share.png);
        }
        &.stats{
          background-image: url(../assets/stats.png);
        }
        &.winner{
          background-image: url(../assets/trophy.png);
        }
        &:hover{
          background-color: #d7d7ea;
          opacity: .7;
        }
      }
      .actionCnt{
        position: absolute;
        background: #fff;
        top: 100%;
        // border: 1px solid #ccc;
        box-shadow: 1px 1px 4px rgba(0,0,0,.2);
        border-radius: 10px;
        padding: 10px 0;
        white-space: nowrap;
        text-align: left;
        right: 14px;
        z-index: 4;
        margin-top: -5px;
        display: none;
        .divider{
          border-top: #eee 1px solid;
          padding-top: 4px;
          margin-top: 4px;
        }
        .actionItem{
          display: block;
          cursor: pointer;
          list-style: none;
          padding: 7px 42px;
          color: #444;
          font-size: 14px;
          min-width: 100px;
          img{
            height: 15px;
            margin: -4px 6px -2px -22px;
            opacity: .7;
          }
        }
        .actionItem.actionRed{
          color: red;
        }
        .actionItem:hover{
          background-color: #eee;
        }
      }
      .actionCnt.open{
        display: block;
      }
      .actionOverlay{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 3;
        display: none;
      }
      .actionOverlay.open{
        display: block;
      }
    }
    td.td1{
      padding-left: 134px;
      .checkCnt{
        margin: 0;
        position: absolute;
        left: 30px; top: 18px;
        .checkboxOuter{
          .checkbox.indeterminate,
          .checkbox.checked{
            background-color: #0e5dd2 !important;
            border-color: #0e5dd2 !important;
          }
        }
      }
      h4{
        margin: 0;
        font-size: 17px;
        font-weight: normal;
        white-space: normal;
        span{
          background: #777;
          color: #fff;
          font-size: 15px;
          padding: 2px 7px;
          border-radius: 3px;
          margin-left: 10px;
          margin-top: 5px;
        }
      }
      p{
        margin: 0;
        white-space: normal;
        font-size: 15px;
        color: #767676;
      }
      .draft{
        padding: 2px 7px 4px;
        background-color: #222;
        color: #fff;
        border-radius: 3px;
        margin-right: 5px;
        display: inline-block;
        .copy{
          width: 20px; height: 20px;
          display: inline-block;
          float: right;
          margin: 1px 0 -4px 4px;
          background-image: url(../assets/copy.png);
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        &.unpublished{
          background-color: #999;
        }
        &.code{
          background: none;
          border: #0e5dd2 2px dashed;
          border-radius: 0;
          font-weight: 600;
          font-size: 16px;
          color: #0e5dd2;
          margin-right: 14px;
          cursor: text;
          cursor: pointer;
        }
        &.number{
          padding: 2px 4px;
          font-weight: 800;
          color: #444;
          background: none;
          span{
            font-weight: normal;
            color: #767676;
          }
        }
      }
    }
    td.tdHeader{
      padding: 0;
    }
  }
}

@keyframes blinking {
  0% {background-color: red;}
  70% {background-color: red;}
  80% {background-color: red;}
  100% {background-color: #fff;}
}
</style>
